import React, {useState, useEffect} from 'react';
import { Dropdown, PrimaryButton, Spinner, SpinnerSize, TextField } from '@fluentui/react';
import appSettings from '../config/Appsettings';
import isoZones from '../config/IsoZones';
import states from '../config/StateList';
import './QuestionGroup.css';
import axios from 'axios';
import './fabric.css';

export function QuestionGroup(props) {
    const { dispatch, state } = props;
    const questions = state.questions;
    const insuredData = state.insured
    const numbersOnly = /^\d+$/;
    const zipCodeUrl = appSettings.rootApiUrl + appSettings.endPoints.zipCode;
    const isoTerritoryUrl = appSettings.rootApiUrl + appSettings.endPoints.isoTerritory;
    const dotScraperUrl = appSettings.rootApiUrl + appSettings.endPoints.dotScrapper;
    const validationButtonText = 'Search';
    const [isHealthy, setIsHealthy] = useState(true);
    // eslint-disable-next-line
    const [healthUrl, setHealthUrl] = useState(dotScraperUrl);

    useEffect(() => {
        axios.get(`${healthUrl}/2933095`)
        .then(response => {
            setIsHealthy(response.status = 200);
        })
        .catch(error => {
            console.error(error);
            setIsHealthy(false);
        });
    }, [healthUrl]);

    const getIsoZonesByState = stateAbbr => {
        const data = isoZones.filter( x => x.stateAbbr === stateAbbr );
        return data.map( x => {
            return {
                key: x.isoZone,
                text: x.display
            }
        });
    };

    const onChangeUsDotNumber = newValue => {
        const val = newValue.target.value;

        if ( val === '' ) {
            questions.showValidateDotButton = true;
        } else if ( val.length <= 10 && validateInput( val, numbersOnly) ) {
            questions.usDotNumber = (val || '');
        }
        questions.dotValidationError = '';
        dispatch( { type: 'updateQuestions', payload: questions});
    };

    const onChangeTargetPremium = newValue => {
        const val = newValue.target.value;
        questions.targetPremuimError = '';

        if ( val === '' ) {
            questions.targetPremuim = '';
        } else {
            if ( validateInput( val, numbersOnly) ) {
                questions.targetPremuim = val;
            } else {
                questions.targetPremuimError = 'Target premium must be a numeric value!'
                questions.targetPremuim = '';
            }
        }
        dispatch( { type: 'updateQuestions', payload: questions});
    }

    const onChangePrimaryZipCode = async newValue => {
        const val = newValue.target.value;
        questions.PrimaryZipCodeValidationError = '';
 
        if ( val.length <= 5 && validateInput( val, numbersOnly) ) {
            if ( val.length === 5) {
                const isoTerritory = await getIsoTerritory(val)
                if ( isoTerritory.isValid ) {
                    questions.primaryZipCode = val;
                    questions.primaryIsoTerritory = isoTerritory.businessAutoTerritory;

                    const zones = getIsoZonesByState( isoTerritory.state );
                    dispatch( { type: 'updateGarageZones', payload: zones});

                } else {
                    questions.primaryZipCodeValidationError = isoTerritory.errorMessage;
                }
            } else {
                questions.primaryIsoTerritory = null;
                questions.primaryZipCode = val;
            }
            dispatch( { type: 'updateQuestions', payload: questions});
        }
    };

    const onChangeGarageZone = (ev, item) => {
        questions.garageZoneError = '';
        questions.garageZone = item.key;

        dispatch( { type: 'updateQuestions', payload: questions});
    }

    const onChangeFarthestState = async (ev, item) => {
        questions.farthestStateError = '';
        questions.farthestState = item.key;

        const zones = getIsoZonesByState( questions.farthestState );
        dispatch( { type: 'updateFarthestZones', payload: zones});

        dispatch( {type: 'updateQuestions', payload: questions});
    };

    const onChangeFarthestZone = (ev, item) => {
        questions.farthestZoneError = '';
        questions.farthestZone = item.key;

        dispatch( { type: 'updateQuestions', payload: questions});
    }
    
    const onChangePowerUnits = newValue => {
        const val = newValue.target.value;
        questions.powerUnitsError = '';

        if ( val.length <= 5 && validateInput( val, numbersOnly) ) {
            questions.powerUnits = (val || '');
            dispatch( { type: 'updateQuestions', payload: questions});
        }
    };

    const validateInput = (fieldValue, restrictionType) => {
        if ( fieldValue !== '' ) {
            if ( restrictionType.test(fieldValue) ) {
                return true;
            }
                return false;
        }
        
        return true;
    };

    const validateZipCode = async (postalCode) => {
        const url = `${zipCodeUrl}/${postalCode}`;
        
        const addressInfo = await axios.get(url)
            .then(response => {
                
                const result = response.data;
                
                if ( postalCode !== result.address.postalCode ) {
                    return {
                        isValid: false,
                        errorMessage: `The ZIP Code ${postalCode} is not valid.`
                    };
                }
                //address.isValid = true;
                return result;
            })
            .catch(error => {
                console.error(error);
                return {
                    isValid: false,
                    errorMessage: `Error Connecting to Bing Maps!\n\n${error.message}`
                }
            });

        if ( !addressInfo.isValid ) {
            return {
                isValid: false,
                errorMessage: `The ZIP Code ${postalCode} is not valid.`
            };
        } else {
            return addressInfo;
        }
    };

    const getIsoTerritory = async (postalCode) => {
        const url = `${isoTerritoryUrl}/${postalCode}`;
        
        return await axios.get(url)
            .then(response => {
                
                const result = response.data;
                
                if ( !result.isValid ) {
                    return {
                        isValid: false,
                        errorMessage: `The ZIP Code ${postalCode} is not valid.`
                    };
                }
                return result;
            })
            .catch(error => {
                console.error(error);
                return {
                    isValid: false,
                    errorMessage: `Error Connecting to NetRate Api!\n\n${error.message}`
                }
            });
    };

    const validateDotNumber = async () => {
        questions.dotValidationError = '';
        questions.isDotNumberValid = false;
        questions.showValidateDotButton = false;
        questions.showValidateDotSpinner = true;
        dispatch( { type: 'updateQuestions', payload: questions});
        try {
            const dotInformation = await callDotScraper();
            
            if ( dotInformation.hasError )
            {
                if ( dotInformation.errorMessage) {
                    if ( dotInformation.errorMessage.response.status === 500 ) {
                        questions.dotValidationError = 'An error occured connecting to the U.S. DOT website!  Is the web site available or has the web site changed?  Check to see if https://ai.fmcsa.dot.gov/SMS/Carrier/ is available and try again.';
                    } else {
                        questions.dotValidationError = 'DOT Number is invalid or could not be found in the U.S. DOT site.!  Please try again...';
                    }
                } else {
                    questions.dotValidationError = 'DOT Number is invalid or could not be found in the U.S. DOT site.!  Please try again...';
                }
                questions.showValidateDotButton = true;
                questions.showValidateDotSpinner = false;
                const target = document.getElementById('InsuredInfo');
                target.scrollIntoView();
                dispatch( { type: 'updateQuestions', payload: questions});
            } else {
                dispatch( { type: 'updateInsured', payload: dotInformation});
                questions.isDotNumberValid = true;
                questions.showValidateDotSpinner = false;
                questions.powerUnits = dotInformation.company.numberOfVehicles;
                
                if ( dotInformation.company.address.zip.trim() !== '' ) {
                    if ( await validateZipCode(dotInformation.company.address.zip) ) {
                        questions.primaryZipCode = dotInformation.company.address.zip.trim();
                        dispatch( { type: 'updateQuestions', payload: questions});
                        onChangePrimaryZipCode({target: {value: dotInformation.company.address.zip.trim()}});
                        
                        const target = document.getElementById('InsuredInfo');
                        target.scrollIntoView();
                    }
                }
                
                dispatch( { type: 'updateQuestions', payload: questions});
            }
        } catch (error) {
            console.error(error);
            questions.dotValidationError = 'DOT Site is unavailable, please try again later.'
            questions.showValidateDotButton = false;
            questions.showValidateDotSpinner = false;
            dispatch( { type: 'updateQuestions', payload: questions});
        }
    }

    const callDotScraper = async () => {
        const url = `${dotScraperUrl}/${questions.usDotNumber}`;
        
        return await axios.get(url)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error(error);
                return {
                    hasError: true,
                    errorMessage: error
                };
            });
    }

    const onChangeInsuredName = newValue => {
        const val = newValue.target.value;
        questions.insuredNameError = '';
        insuredData.company.name = val;
        dispatch( { type: 'updateInsured', payload: insuredData});
    };

    const onChangeAddress1 = newValue => {
        const val = newValue.target.value;
        questions.insuredStreetError  = '';
        insuredData.company.address.street1 = val;
        dispatch( { type: 'updateInsured', payload: insuredData});
    };

    const onChangeAddress2 = newValue => {
        const val = newValue.target.value;
        insuredData.company.address.street2 = val;
        dispatch( { type: 'updateInsured', payload: insuredData});
    };

    const onChangeCity = newValue => {
        const val = newValue.target.value;
        questions.insuredCityError = '';
        insuredData.company.address.city = val;
        dispatch( { type: 'updateInsured', payload: insuredData});
    };

    const onChangeState = (ev, item) => {
        questions.insuredStateError = '';
        insuredData.company.address.state = item.key;
        dispatch( { type: 'updateInsured', payload: insuredData});
    };

    const onChangeZip = newValue => {
        const val = newValue.target.value;
        questions.insuredZipError = '';
        insuredData.company.address.zip = val;
        dispatch( { type: 'updateInsured', payload: insuredData});
    };

    return (
        <div className="the-container-container">
            <div className="questionGroup-container">
                <div className="flex">
                    <div className="mr-md">
                        <span className="questionGroup-number">1</span>
                    </div>
                    <div className="flex-1">
                        <h2 className="questionGroup-label" id="Premium">
                            Premium
                        </h2>
                        <table>
                        <tbody>
                            <tr>
                                <td style={{width: 290}}>
                                    <h4 id="TargetPremium" style={{paddingTop: 7}}>
                                        Target or Expiring Premium Per Power Unit:
                                    </h4>
                                </td>
                                <td style={{verticalAlign: 'top'}} >
                                    <TextField 
                                        value={questions.targetPremuim || ""} 
                                        errorMessage={questions.targetPremuimError}
                                        styles={{ fieldGroup: { width: 80 } }}
                                        onChange={onChangeTargetPremium}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
            <div className="questionGroup-container">
                <div className="flex">
                    <div className="mr-md">
                         <span className="questionGroup-number">2</span>
                    </div>
                    <div className="flex-1">
                        <h2 className="questionGroup-label" id="InsuredInfo">
                            Insured Info
                        </h2>
                        <table>
                            <tbody>
                                <tr>
                                    <td style={{paddingRight: '10px', width: 350}}>
                                        <h4  style={{paddingTop: 12}} id="OperatingRadius">
                                            Enter Insured's US DOT number to look up the Insured:
                                        </h4>
                                    </td>
                                    <td style={{align: 'left'}}>
                                        <TextField 
                                            value={questions.usDotNumber} 
                                            onChange={onChangeUsDotNumber} 
                                            errorMessage={questions.dotValidationError}
                                            styles={{ fieldGroup: { width: 100 } }}
                                        />
                                    </td>                                    
                                    <td style={{paddingLeft: 10}}>
                                        {(questions.showValidateDotButton && (isHealthy ? <PrimaryButton text={validationButtonText} onClick={validateDotNumber} /> : <p><b>FMCSA Services are not available right now</b></p>))}
                                        {questions.showValidateDotSpinner && (<Spinner size={SpinnerSize.medium} />)}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                    {questions.isDotNumberValid && (
                                    <>
                                    <br/>
                                    <hr/>
                                    <br/>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td style={{verticalAlign: 'top', width: 100}} id="InsuredName">Insured name:</td>
                                                    <td>
                                                    <TextField
                                                        value={insuredData.company.name} 
                                                        errorMessage={questions.insuredNameError}
                                                        styles={{ fieldGroup: { width: 480 } }} 
                                                        onChange={onChangeInsuredName}
                                                    />
                                                    <br/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{verticalAlign: 'top'}}>Address:</td>
                                                    <td>
                                                    <TextField
                                                        value={insuredData.company.address.street1} 
                                                        errorMessage={questions.insuredStreetError}
                                                        styles={{ fieldGroup: { width: 480 } }} 
                                                        onChange={onChangeAddress1}
                                                    />
                                                    <br/>
                                                    <TextField
                                                        value={insuredData.company.address.street2} 
                                                        errorMessage=""
                                                        styles={{ fieldGroup: { width: 480 } }} 
                                                        onChange={onChangeAddress2}
                                                    />
                                                    <br/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>
                                                        <TextField
                                                            value={insuredData.company.address.city} 
                                                            errorMessage={questions.insuredCityError}
                                                            styles={{ fieldGroup: { width: 280 } }}
                                                            onChange={onChangeCity}
                                                        />
                                                        <br/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>
                                                        <Dropdown 
                                                            selectedKey={insuredData.company.address.state}
                                                            onChange={onChangeState}
                                                            placeholder="Select an option"
                                                            options={states}
                                                            errorMessage={questions.insuredStateError}
                                                            styles={{ dropdown: { width: 200 } }}
                                                        />
                                                        <br/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>
                                                        <TextField
                                                            value={insuredData.company.address.zip} 
                                                            errorMessage={questions.insuredZipError}
                                                            styles={{ fieldGroup: { width: 80 } }}
                                                            onChange={onChangeZip}
                                                            mask="Zip: 99999"
                                                        />
                                                        <br/>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                    )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            { questions.isDotNumberValid && (
                <>                
                <div className="questionGroup-container">
                    <div className="flex">
                        <div className="mr-md">
                            <span className="questionGroup-number">3</span>
                        </div>
                        <div className="flex-1">
                            <h2 className="questionGroup-label" id="Question2">
                                Trucking Details
                            </h2>
                            <table>
                                <tbody>
                                    <tr>
                                        <td style={{width: 120}}>
                                        <h4 className="questionGroup-label" id="PowerUnits">
                                            # Power Units:
                                        </h4>
                                        </td>
                                        <td>
                                            <TextField 
                                                label="" 
                                                value={questions.powerUnits} 
                                                errorMessage={questions.powerUnitsError}
                                                styles={{ fieldGroup: { width: 100 } }} 
                                                onChange={onChangePowerUnits}
                                            />
                                            <br/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        
                            <h4 className="questionGroup-label" id="OperatingRadius">
                                Operating Radius:
                            </h4>
                            { (Number(questions.operatingRadius50) + Number(questions.operatingRadius200) + Number(questions.operatingRadius200plus)) === 100 && (
                                <table>
                                <tbody>
                                    <tr>
                                        <td style={{width: 20}}>&nbsp;</td>
                                        <td style={{width: 240}}>
                                            <br/>
                                            <TextField 
                                                label="Primary Garage Zip Code" 
                                                value={questions.primaryZipCode} 
                                                errorMessage={questions.primaryZipCodeValidationError} 
                                                mask="Zip: 99999"
                                                styles={{ fieldGroup: { width: 80 } }} 
                                                onChange={onChangePrimaryZipCode}
                                            />
                                            <br/>
                                        </td>
                                        <td>
                                            { questions.primaryIsoTerritory !== null && questions.primaryZipCode.length === 5 && (
                                            <>
                                                <Dropdown 
                                                    label="Garage Zone"
                                                    selectedKey={questions.garageZone}
                                                    onChange={onChangeGarageZone}
                                                    placeholder="Select an option"
                                                    options={state.garageZoneOptions}
                                                    errorMessage={questions.garageZoneError}
                                                />
                                            </>
                                            )}
                                        </td>
                                    </tr>
                                        { Number(questions.operatingRadius200plus) >= 20 && (
                                            <tr>
                                                <td style={{width: 20}}>&nbsp;</td>
                                                <td style={{width: 240}}>
                                                    <Dropdown 
                                                        label="Farthest Terminal State"
                                                        selectedKey={questions.farthestState}
                                                        onChange={onChangeFarthestState}
                                                        placeholder="Select an option"
                                                        options={states}
                                                        errorMessage={questions.farthestStateError} 
                                                    />
                                                </td>
                                                <td>
                                                { state.farthestZoneOptions.length !== 0 && (
                                                <>
                                                    <Dropdown 
                                                        label="Farthest Zone"
                                                        selectedKey={questions.farthestZone}
                                                        onChange={onChangeFarthestZone}
                                                        placeholder="Select an option"
                                                        options={state.farthestZoneOptions}
                                                        errorMessage={questions.farthestZoneError} 
                                                    />
                                                </>
                                                )}
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                            )}
                        </div>
                    </div>
                </div>
                </>
            )}
            <hr/>
        </div>
	);
};